import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/**
 * @typedef {Object} LocationOption
 * @property {number} id
 * @property {string} name
 * @property {boolean} [has_home_page]
 */

/**
 * @typedef {Object} LocationsState
 * @property {LocationOption[]} options - Lightweight location options for dropdowns
 *
 * @typedef {import('../slice.types').BaseSlice & LocationsState} LocationsSlice
 */

/** @type {LocationsSlice} */
export const initialLocationsState = {
  status: 'init',
  errors: [],
  options: []
}

/** @enum {string} */
export const LOCATIONS_ACTIONS = {
  SET_LOCATIONS_STATUS: 'SET_LOCATIONS_STATUS',
  SET_LOCATIONS_ERRORS: 'SET_LOCATIONS_ERRORS',
  SET_LOCATION_OPTIONS: 'SET_LOCATION_OPTIONS'
}

export const locationOptionPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string
})

export const locationsSlicePropTypes = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  options: PropTypes.arrayOf(locationOptionPropTypes)
})

/**
 * @typedef {{ type: LOCATIONS_ACTIONS, payload: LocationsSlice['status'] }} LocationsStatusAction
 * @typedef {{ type: LOCATIONS_ACTIONS, payload: LocationsSlice['errors'] }} LocationsErrorsAction
 * @typedef {{ type: LOCATIONS_ACTIONS, payload: LocationOption[] }} LocationOptionsAction
 *
 * @typedef {LocationsStatusAction | LocationsErrorsAction | LocationOptionsAction} LocationsAction
 */
